<template>
  <v-dialog v-model="declineEmployeeDialog" max-width="800px" :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card v-if="employee">
      <v-card-title class="primary white--text">
        <h3>{{ $t('texts.declineRequest') }} ({{ employee.employee_first_name }} {{ employee.employee_last_name }})</h3>
        <v-spacer/>
        <v-btn text small fab @click.native="declineEmployeeDialog = false">
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <form>
          <strong>{{ $t('texts.chooseReason') }}</strong>
          <v-radio-group
            v-model="form.reason"
            required
            :error-messages="errors.collect('reason')"
            v-validate="'required'"
            data-vv-name="reason"
            :data-vv-as="$t('texts.reason')"
          >
            <v-radio
              :label="$t('texts.declineEmployeeTypes.UNKNOWN')"
              value="UNKNOWN"
              color="primary"
            />
            <v-radio
              :label="$t('texts.declineEmployeeTypes.DATE')"
              value="DATE"
              color="primary"
            />
            <v-radio
              :label="$t('texts.declineEmployeeTypes.TITLE')"
              value="TITLE"
              color="primary"
            />
            <v-radio
              :label="$t('texts.declineEmployeeTypes.OTHER')"
              value="OTHER"
              color="primary"
            />
          </v-radio-group>
          <v-textarea
            v-model="form.explanation"
            :label="$t('texts.reasonDetail')"
          />
        </form>
      </v-card-text>
      <v-divider/>
      <v-card-actions class="pr-3">
        <v-spacer/>
        <v-btn
          color="primary"
          class="white--text"
          @click="handleDeclineEmployee(employee.resume_entry_id)"
          :disabled="storeEmployeeAssignmentPending"
          :loading="storeEmployeeAssignmentPending"
        >
          {{ $t('texts.decline') }}
          <v-icon right class="white--text">check_circle</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapCompanyEmployeesState, mapActions: mapCompanyEmployeesActions } = createNamespacedHelpers('company/employees');
const { mapActions: mapMessageActions } = createNamespacedHelpers('messages');

export default {
  name: 'DeclineEmployeeDialog',
  data() {
    return {
      declineEmployeeDialog: false,
      form: {
        explanation: null,
        reason: null,
      },
      employee: {},
    };
  },
  $_veeValidate: {
    validator: 'new',
  },
  mounted() {
    this.$eventBus.$on('show-decline-employee-dialog', (payload) => {
      Object.assign(this.employee, payload);
      this.form.explanation = null;
      this.form.reason = null;
      this.$validator.reset();
      this.declineEmployeeDialog = true;
    });
  },
  computed: {
    ...mapCompanyEmployeesState([
      'storeEmployeeAssignmentPending',
    ]),
    select() {
      const select = [
        { text: this.$i18n.t('texts.applicationStatus.INTERVIEW'), value: 'INTERVIEW' },
        { text: this.$i18n.t('texts.applicationStatus.CONTRACTSENT'), value: 'CONTRACTSENT' },
        { text: this.$i18n.t('texts.applicationStatus.CONTRACTSIGNED'), value: 'CONTRACTSIGNED' },
        { text: this.$i18n.t('texts.applicationStatus.REFUSAL'), value: 'REFUSAL' },
      ];
      return select;
    },
    selectedCompanyId() {
      return this.$route.params.companyId;
    },
  },
  methods: {
    ...mapCompanyEmployeesActions([
      'updateEmployeeAssignment',
    ]),
    ...mapMessageActions([
      'showMessageValidateError',
    ]),
    handleDeclineEmployee() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const payload = {
            type: 'decline',
            companyId: this.selectedCompanyId,
            entryId: this.employee.resume_entry_id,
            form: { ...this.form },
          };
          this.updateEmployeeAssignment(payload).then(() => {
            this.declineEmployeeDialog = false;
          });
        } else {
          this.showMessageValidateError();
        }
      });
    },
  },
};
</script>
